import { render, staticRenderFns } from "./MensalidadesAtivos.vue?vue&type=template&id=53c5818a&scoped=true&"
import script from "./MensalidadesAtivos.vue?vue&type=script&lang=js&"
export * from "./MensalidadesAtivos.vue?vue&type=script&lang=js&"
import style0 from "./MensalidadesAtivos.vue?vue&type=style&index=0&id=53c5818a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c5818a",
  null
  
)

export default component.exports